import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

const EncuestasPorTipo = () => {
  const { tipoEncuesta, solicitud } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const cookie = new Cookies();

  // Modal comentarios
  const [showModal, setShowModal] = useState(false);
  const [comentarios, setComentarios] = useState([]);
  const [comentarioNuevo, setComentarioNuevo] = useState("");
  const [encuestaSeleccionada, setEncuestaSeleccionada] = useState(null);
  const [loadingComentarios, setLoadingComentarios] = useState(false);

  /* ===========================
     CARGAR ENCUESTAS
  ============================ */
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerEncuestasPorSolicitudId/${tipoEncuesta}/${solicitud}`,
    })
      .then((response) => setData(response.data || []))
      .catch(() => alert("Error cargando encuestas"))
      .finally(() => setLoading(false));
  }, [tipoEncuesta, solicitud]);

  /* ===========================
     HELPERS
  ============================ */
  const getBadgeClass = (estado) => {
    switch (estado?.toLowerCase()) {
      case "incompleta":
        return "badge-warning";
      case "cancelada":
        return "badge-danger";
      case "en proceso":
        return "badge-info";
      default:
        return "badge-success";
    }
  };

  const getTipoEncuesta = (id) => {
    switch (id) {
      case 1:
        return "Usuario";
      case 2:
        return "Trabajador";
      case 3:
        return "Paciente trazador";
      default:
        return "No definido";
    }
  };

  /* ===========================
     ABRIR MODAL + LISTAR
  ============================ */
  const abrirComentarios = async (item) => {
    setEncuestaSeleccionada(item);
    setShowModal(true);
    setComentarioNuevo("");
    setLoadingComentarios(true);

    try {
      const response = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerComentariosEncuesta/${item.id}`,
      );
      setComentarios(response.data || []);
    } catch {
      setComentarios([]);
    } finally {
      setLoadingComentarios(false);
    }
  };

  /* ===========================
     GUARDAR COMENTARIO
  ============================ */
  const guardarComentario = async () => {
    if (!comentarioNuevo.trim()) {
      alert("El comentario no puede estar vacío");
      return;
    }

    try {
      await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/AgregaComentariosEncuesta",
        {
          EncuestaId: encuestaSeleccionada.id,
          SolicitudId: Number(solicitud),
          TipoEncuestaId: encuestaSeleccionada.idTipoEncuesta,
          UsuarioId: cookie.get("id"), // ← ajustar luego con sesión
          Comentarios: comentarioNuevo,
        },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      setComentarioNuevo("");
      abrirComentarios(encuestaSeleccionada); // recarga
    } catch {
      alert("Error al guardar comentario");
    }
  };

  if (loading) return <p className="text-center">Cargando...</p>;

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header">
          <h5 className="text-primary">
            Detalle de Encuestas – Solicitud {solicitud}
          </h5>
        </div>

        <div className="card-body table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="thead-light">
              <tr>
                <th>#</th>
                <th>Tipo</th>
                <th>Evaluador</th>
                <th>Fecha</th>
                <th>Sede</th>
                <th>Servicio</th>
                <th>Estado</th>
                <th>Detalles</th>
                <th>Comentarios</th>
                <th>Continuar</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>
                      <span className="badge badge-secondary">
                        {getTipoEncuesta(item.idTipoEncuesta)}
                      </span>
                    </td>
                    <td>{item.evaluador}</td>
                    <td>
                      {item.fecha
                        ? new Date(item.fecha).toLocaleDateString("es-CO")
                        : "-"}
                    </td>
                    <td>{item.sede}</td>
                    <td>{item.servicio || "-"}</td>
                    <td className="text-center">
                      <span
                        className={`badge ${getBadgeClass(item.estadoEncuesta)}`}
                      >
                        {item.estadoEncuesta}
                      </span>
                    </td>
                    <td className="text-center">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => navigate(`/DetalleEncuesta/${item.id}`)}
                      >
                        Ver detalle
                      </button>
                    </td>

                    <td>
                      {" "}
                      <button
                        className="btn btn-dark btn-sm"
                        onClick={() => abrirComentarios(item)}
                      >
                        Comentarios
                      </button>
                    </td>
                    <td className="text-center">
                      <button
                        className="btn btn-info btn-sm"
                        onClick={() =>
                          navigate(
                            `/PresentaEncuesta/${item.idTipoEncuesta}/${item.id}/${solicitud}`,
                          )
                        }
                      >
                        Continuar
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No hay encuestas registradas
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= MODAL COMENTARIOS ================= */}
      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ background: "rgba(0,0,0,.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  💬 Comentarios Encuesta #{encuestaSeleccionada?.id}
                </h5>
                <button
                  className="close text-white"
                  onClick={() => setShowModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>

              <div className="modal-body">
                {loadingComentarios ? (
                  <p className="text-center">Cargando comentarios...</p>
                ) : comentarios.length > 0 ? (
                  <div
                    className="list-group mb-3"
                    style={{
                      maxHeight: "300px",
                      overflowY: "auto",
                      border: "1px solid #dee2e6",
                      borderRadius: "5px",
                    }}
                  >
                    {comentarios.map((c, i) => (
                      <li key={i} className="list-group-item">
                        <small className="text-muted">
                          {c.usuario || "Usuario"} •{" "}
                          {c.fecha
                            ? new Date(c.fecha).toLocaleString("es-CO")
                            : ""}
                        </small>
                        <p className="mb-0">{c.comentarios}</p>
                      </li>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted text-center">
                    No hay comentarios registrados
                  </p>
                )}

                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Escribe un nuevo comentario..."
                  value={comentarioNuevo}
                  onChange={(e) => setComentarioNuevo(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </button>
                <button className="btn btn-success" onClick={guardarComentario}>
                  Guardar comentario
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EncuestasPorTipo;
